'use memo';

import type { ReactNode } from 'react';
import { StatCard, StatCardTitle } from '@/components/Card/StatCard';
import { Text } from '@/components/Typography';
import { cn } from '@/lib/cn';
type Props<T> = {
  title: string;
  items: T[];
  emptyLabel: string;
  /** リスト 1 行を返す関数。返り値は <li> 内に描画される */
  renderItem: (item: T, index: number) => ReactNode;
  /** 各 item の React key 用 */
  getItemKey: (item: T, index: number) => string;
  className?: string;
};

/**
 * 縦リスト型 Slot — Slot 7（スケジュール）/ Slot 8（アクティビティ）で
 * 利用するジェネリック共通コンポーネント。
 * 1 つの StatCard 内にタイトル + リストを描画し、空データ時は emptyLabel を表示する。
 * a11y: 複数項目のリストは <ul>/<li> でセマンティック構造を提供する。
 */
export function StatCardListSlot<T>({
  title,
  items,
  emptyLabel,
  renderItem,
  getItemKey,
  className
}: Props<T>) {
  return <StatCard className={cn('flex flex-col min-h-[240px]', className)}>
      <StatCardTitle>{title}</StatCardTitle>
      {items.length === 0 ? <Text variant="pSmall" className="mt-3 text-neutral-muted-on-fill">
          {emptyLabel}
        </Text> : <ul className="mt-3 flex-1 flex flex-col gap-2 overflow-y-auto pr-1">
          {items.map((item, index) => <li key={getItemKey(item, index)}>{renderItem(item, index)}</li>)}
        </ul>}
    </StatCard>;
}